// @flow

/**
 * Small utility function to return the exact character length of a string,
 * counting international characters.
 */
const inputLength = (input: ?string): number => {
  if (!input) {
    return 0;
  }

  let len = 0;
  for (let i = input.length - 1; i >= 0; i--) {
    len += 1;
    const c = input.charCodeAt(i);
    if (
      (c >= 0x4e00 && c <= 0x9fff) || // Chinese
      (c >= 0x3040 && c <= 0x30ff) || // Japanese
      (c >= 0xac00 && c <= 0xd7ff) // Korean
    ) {
      len += 1;
    }
  }
  return len;
};

const stringHash = (str: string) => {
  let hash: number = 5381;
  let i: number = str.length;

  while (i) {
    // eslint-disable-next-line no-bitwise
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  // eslint-disable-next-line no-bitwise
  return hash >>> 0;
};

const uuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export { inputLength, stringHash, uuid };
